export default __webpack_public_path__ + "static/media/carlton-face.9fe0f414.png";